import React from 'react';
import { Layout } from '../../layout/Layout';
import BackupRestoreDB from '../../componen/BackupRestoreDB';

const BackupRestoreDBPages = () => {
  return (
    <Layout>
      <BackupRestoreDB />
    </Layout>
  );
};

export default BackupRestoreDBPages;
